export const updateSessionId = 'update_session_id';
